import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import IMG_1 from 'assets/images/customer/customer-header-banner-pc.png'
import IMG_2 from 'assets/images/customer/customer-header-banner-mobile.png'
import IMG_3 from 'assets/images/customer/mail.png'
import { DOWNLOAD_INFO } from 'assets/json/customerInfo.js'
import { URL } from '../../utils/Utils'
import CustomerMain from './CustomerMain'
import CustomerTitle from './components/CustomerTitle'
import MailSendPopup from './MailSendPopup'
import './CustomerDownload.scss'

/**
 * @file [고객지원]-[자료실] 화면
 */
function CustomerDownload() {
    const handleDownload = myObject => {
        //console.log('handleDownload() myObject : ', myObject)
        // Fetch the PDF file
        fetch(myObject.path)
            .then(response => response.blob())
            .then(blob => {
                // Create a blob URL representing the PDF file
                const blobUrl = window.URL.createObjectURL(blob)

                // Create a link element
                const a = document.createElement('a')
                a.href = blobUrl
                //a.download = myObject.title + myObject.fileType
                a.download = myObject.file_name

                // Append the link to the document and click it
                document.body.appendChild(a)
                a.click()

                // Clean up after the download
                window.URL.revokeObjectURL(blobUrl)
            })
    }

    return (
        <>
            <CustomerMain />
            <div className="customer-body-wrap">
                <div className="customer-download-wrap-one">
                    <CustomerTitle
                        title="자료실"
                        sub="차량의 사용설명서 및 각종 매뉴얼/설명자료를 다운로드 할 수 있습니다."
                    />
                    <div className="customer-download-table-wrap pc">
                        <table className="customer-download-table-pc">
                            <colgroup>
                                <col width="12.58%" />
                                <col width="34.55%" />
                                <col width="38.41%" />
                                <col width="14.46%" />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th>순번</th>
                                    <th>자료명</th>
                                    <th>해당기종</th>
                                    <th>다운로드</th>
                                </tr>
                            </thead>
                            <tbody>
                                {DOWNLOAD_INFO.length > 0 &&
                                    DOWNLOAD_INFO.map((val, i) => (
                                        <tr key={`customer-download-table-box-pc-${i}`}>
                                            <td>{i + 1}</td>
                                            <td>{val.title}</td>
                                            <td>{val.kind}</td>
                                            <td
                                                className="customer-download-table-download-wrap"
                                                onClick={() => handleDownload(val)}>
                                                <img
                                                    className="download_icon"
                                                    src={require('../../assets/images/customer/file-save-pc.png')}
                                                    alt="다운로드"
                                                />
                                                <span>{val?.fileTypeText}</span>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="customer-download-table-wrap pad">
                        {DOWNLOAD_INFO.length > 0 &&
                            DOWNLOAD_INFO.map((val, i) => (
                                <div
                                    className="customer-download-table-box"
                                    key={`customer-download-table-box-pad-${i}`}>
                                    <table className="customer-download-table-pad">
                                        <colgroup>
                                            <col width="14.32%" />
                                            <col width="85.67%" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>자료명</th>
                                                <td>{val.title}</td>
                                            </tr>
                                            <tr>
                                                <th>해당기종</th>
                                                <td>{val.kind}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div
                                        className="customer-download-table-download-wrap"
                                        onClick={() => handleDownload(val)}>
                                        <img
                                            className="download_icon"
                                            src={require('../../assets/images/customer/file-save-pc.png')}
                                            alt="다운로드"
                                        />
                                        <span>{val?.fileTypeText}</span>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerDownload
